import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API, setToken, formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-disco-void flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <Link to="/" data-testid="admin-login-home-link">
            <Logo size={44} />
          </Link>
        </div>
        <form
          data-testid="admin-login-form"
          onSubmit={submit}
          className="bg-disco-surface border border-white/10 p-8 space-y-5"
        >
          <h1 className="font-display uppercase tracking-wide text-3xl text-[#F8F8F8] text-center">
            Staff Login
          </h1>

          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-400 text-center">
              {error}
            </p>
          )}

          <div className="space-y-2">
            <Label htmlFor="admin-email" className="text-zinc-300 text-xs uppercase tracking-widest">Email</Label>
            <Input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white/5 border-white/10 text-zinc-100 focus-visible:ring-disco-yellow"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="text-zinc-300 text-xs uppercase tracking-widest">Password</Label>
            <Input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white/5 border-white/10 text-zinc-100 focus-visible:ring-disco-yellow"
            />
          </div>
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-disco-yellow text-disco-void font-semibold py-3 text-sm transition-all duration-300 hover:shadow-[0_0_24px_rgba(226,255,0,0.4)] active:scale-[0.98] disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
